import React from 'react'
import { Link } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import imgalert from '../../img/warning.png'
function NoMatch() {
  const { t } = useTranslation();
  return (
    <>
      <section className="px-4 py-24 mx-auto max-w-7xl bg-light">
        <div className="container col-xxl-8 px-4 py-5">
          <div className="row flex-lg-row-reverse align-items-center g-5 py-5">
            <div className="col-10 col-sm-8 col-lg-4">
              <img src={imgalert} alt="Bootstrap Themes" width="400" height="400" loading="lazy" />
            </div>
            <div className="col-lg-8">
              <h1 className="display-5 fw-bold lh-1 mb-3 text-color-sp">{t('notFound.message')}</h1>
              <div className="justify-content-start">
                <Link to='/'>
                  <button type="button"
                    className="btn btn-lg bg-color-sp fw-bold border rounded shadow-sm">
                    <i className="uil uil-arrow-left"></i>
                    {t('notFound.backHome')}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default NoMatch